export const mapAudioFileInput = file => {
  var _file$media, _file$media2, _file$media3;
  return {
    bitrate: ((_file$media = file.media) == null || (_file$media = _file$media.audio) == null ? void 0 : _file$media.bitrate) || 0,
    channels: -1,
    duration: ((_file$media2 = file.media) == null || (_file$media2 = _file$media2.audio) == null ? void 0 : _file$media2.duration) || 0,
    format: ((_file$media3 = file.media) == null || (_file$media3 = _file$media3.audio) == null ? void 0 : _file$media3.format) || '',
    id3: {
      track_year: 0
    },
    sample_rate: -1
  };
};
export const mapBaseAudio = (audio, file) => {
  var _file$media4;
  const bitrate = ((_file$media4 = file.media) == null || (_file$media4 = _file$media4.audio) == null ? void 0 : _file$media4.bitrate) || 0;
  const operationStatus = file.operationStatus || 'READY';
  return {
    audio_bitrate: bitrate,
    duration: audio.duration || 0,
    format: audio.format || '',
    key: audio.assetKey || '',
    secure: Boolean(audio.private),
    status: operationStatus,
    tag: ''
  };
};
export const mapBaseAudioFile = (file, baseFile) => ({
  ...baseFile,
  fileInput: mapAudioFileInput(file),
  height: null,
  width: null,
  videoPreviewUrls: null
});
//# sourceMappingURL=BaseAudio.mappers.js.map